import { useEffect, useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

type ImageBlob = {
  id: string
  url: string
}

interface Props {
  images: ImageBlob[]
}

export const Carousel = ({ images }: Props) => {
  const [activeImage, setActiveImage] = useState<string>()
  const [listStart, setListStart] = useState(0)

  useEffect(() => {
    setActiveImage(images[0]?.id)
  },[images, setActiveImage])

  if (images.length == 0) return

  return (
    <div className="flex flex-col gap-6 items-center">
      <div className="flex items-centerborder border-zinc-300">
        <img
          src={images.find(v => v.id == activeImage)?.url}
          className={`p-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-100 dark:bg-zinc-800 max-w-96
                      max-h-96 object-contain`}
        />
      </div>
      <div className="flex flex-row justify-around w-full items-center">
        <ChevronLeftIcon
          className={`size-12 ${listStart == 0 ? 'text-gray-300 dark:text-gray-600' : ''}`}
          onClick={() => setListStart(v => v > 0 ? v - 1: v)}
        />
        { images.slice(listStart, listStart + 3).map(v => (<img
          key={v.id}
          src={v.url}
          className={`p-2 max-w-48 max-h-48 object-contain self-center rounded-md border border-zinc-300
                      dark:border-zinc-700 bg-zinc-100 hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-700`}
          onClick={() => setActiveImage(v.id)}
        />)) }
        <ChevronRightIcon
          className={`size-12 ${listStart + 3 > images.length - 1 ? 'text-gray-300 dark:text-gray-600' : ''}`}
          onClick={() => setListStart(v => v + 3 < images.length ? v + 1 : v)}
        />
      </div>
    </div>
  )
}
